export default __webpack_public_path__ + "_/images/promo_action/instructions/image3-4f340259f8a60ae583342afe7cab0fd678dda6527eb76982b161e9c103a32a05.png";